(function($){
  "use strict";

  const behaviorOptions = {
    name: 'IzzyPopup',
    selector: 'header',
  };

  function behavior(context, settings) {
    $(once(behaviorOptions.name, behaviorOptions.selector, context)).each(function(index, element) {
      $(function() {
        window.izzy_popup = new IzzyPopup(element);
      });
    });
  }

  Drupal.behaviors[behaviorOptions.name] = {
    attach: function(context, settings){
      behavior(context, settings);
    },
  }

  // Init self in case we are loaded async.
  if (jQuery.isReady) {
    // It is up to script to define scope and settings it should be applied to
    // in case of jquery mobile integration used you can use site_common.jquery_mobile.getPageContext()
    // to get only current page's context.
    // In this example we use global scope.
    const context = document;
    const settings = Drupal.settings;
    Drupal.behaviors[behaviorOptions.name].attach(context, settings);
  }

    class IzzyPopup
    {
        constructor()
        {
            this.options =
            {
                SEL_MAIN:            '[data-popup-page-id]',
                SEL_POPUP_ALL:       '.popup',
                SEL_BTN_CLOSE:       '.btn-close',
                SEL_POPUP_MAIN:      '.popup__main',
                SEL_POPUP_BODY:      '.popup__body',
                CLS_POPUP:           'popup',
                CLS_POPUP_MAIN:      'popup__main',
                CLS_POPUP_BODY:      'popup__body',
                CLS_POPUP_PAGE:      'popup__page',
                CLS_OPENED:          'popup--opened',
                CLS_BTN_POPUP_CLOSE: 'btn-close',
                SEL_HEADER_INNER:    'header__inner'
            };

            this.popup              = null;
            this.popup_main         = null;
            this.popup_body         = null;
            this.button_mob_main    = null;
            this.button_popup_open  = null;
            this.button_popup_close = null;

            this.OnKeyDel = this._OnKey.call(this, this);

            this.Init();

        } // constructor

        Init()
        {
            let _links_list = Array.prototype.slice.call( document.querySelectorAll( this.options.SEL_MAIN ) );

            // insert mobile opener
            {
                let _path = drupalSettings.izzy.theme_path;

                let _tmplt_btn_open_str = `
                    <div class="navmain__btn-mob" data-popup-page-id="popup-page-main">
                      <svg>
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${drupalSettings.izzy.theme_path}/images/sprite.svg#ico-navbar-mobile"></use>
                      </svg>
                    </div>`;

                document.querySelector( `.${this.options.SEL_HEADER_INNER}` ).insertAdjacentHTML( 'beforeend', _tmplt_btn_open_str );
                this.button_popup_open = document.querySelector( 'header .navmain__btn-mob' );

                _links_list.push( document.querySelector( 'header .navmain__btn-mob' ) );
            }

            if( _links_list.length < 1 ) return;

            this.popup              =   document.querySelector( `.${this.options.CLS_POPUP}` );
            this.popup_main         = this.popup.querySelector( `.${this.options.CLS_POPUP_MAIN}` );
            this.popup_body         = this.popup.querySelector( `.${this.options.CLS_POPUP_BODY}` );
            this.button_popup_close = this.popup.querySelector( `.${this.options.CLS_BTN_POPUP_CLOSE}` );

            document.body.insertBefore( this.popup, document.body.firstChild );

            for( let x = 0; x < _links_list.length; x++ )
            {
                let _button = _links_list[x];
                let _loop = Object.create(null);
                _loop.button_opener     = _button;
                _loop.popup_linked_page = document.getElementById(_button.attributes['data-popup-page-id'].value);

                _loop.button_opener    ._loop = _loop;
                if (_loop.popup_linked_page) {
                    _loop.popup_linked_page._loop = _loop;
                }

                _button.addEventListener( 'click', this._OnBtnPopupOpen(this) );

                this.UpdateAniDur();
            }

            // add 'order' for page sorting when/if need in future
            {
                let _pages_list = Array.prototype.slice.call( this.popup_body.querySelectorAll(`.${this.options.CLS_POPUP_PAGE}`) );

                for( let x = 0; x < _pages_list.length; x++ )
                {
                    _pages_list[x].style['order'] = x;
                }

                this.popup_body.style['width'] = `${_pages_list.length*100}vw`;
            }

            this.button_popup_close.addEventListener( 'click', this._OnBtnPopupClose(this) );

            this.popup_main.addEventListener( 'transitionend', this._OnTransEnd(this) );
            this.popup_body.addEventListener( 'transitionend', this._OnTransEnd(this) );

            window.addEventListener('breakpointchange', (e) => {
                if( e.detail.currentBreakpoint === 'desktop' )
                {
                    this._HideAll();
                }
            });

        } // Init

        _IsButtonExternal( obj_check )
        {
            let _parent = obj_check.offsetParent;
            while( _parent != null )
            {
                if( _parent.classList.contains( this.options.CLS_POPUP ) )
                {
                    return false;
                }

                _parent = _parent.offsetParent;
            }

            return true;

        } // _IsButtonExternal

        // @public
        OpenMenu( _loop, force = false )
        {
            if( !force ) this.UpdateAniDur();

            if( !this.popup.classList.contains( this.options.CLS_OPENED ) ) // outer link
            {
                this.popup.classList.add( this.options.CLS_OPENED );
                document.addEventListener( 'keydown', this.OnKeyDel );
            }

            let _page_index = 1;
            if (_loop.popup_linked_page) {
                _page_index = parseInt( _loop.popup_linked_page.style['order'] );
            }
            _page_index = (_page_index * 100);

            this.popup_body.style['transform'] = `translate3d(-${_page_index}vw, 0, 0)`;

            document.body.classList.add('mobile-menu-is-opened');

        } // OpenMenu

        // @public
        CloseMenu( _loop, force = false )
        {
            if( !force ) this.UpdateAniDur();

            if( this.popup.classList.contains( this.options.CLS_OPENED ) ) // outer link
            {
                this.popup.classList.remove( this.options.CLS_OPENED );
                document.removeEventListener( 'keydown', this.OnKeyDel );
            }

            this.popup_body.style['transform'] = `translate3d(0, 0, 0)`;

            document.body.classList.remove('mobile-menu-is-opened');

        } // CloseMenu

        // @public
        UpdateAniDur()
        {
            let _win_width = window.innerWidth;
            let _dur = 250;

            if( _win_width <= 320 )
            {
                _dur = 250;
            }
            else if( _win_width <= 768 )
            {
                _dur = 300;
            }
            else
            {
                _dur = 400;
            }

            this.popup_body.style['transition-duration'] = `${_dur}ms`;
            this.popup_main.style['transition-duration'] = `${_dur}ms`;

        } // UpdateAniDur

        _OnTransEnd( _self )
        {
            return function(e)
            {
                _self.popup_body.style['transition-duration'] = null;
                _self.popup_main.style['transition-duration'] = null;
            }

        } // _OnTransEnd

        _OnBtnPopupClose( _self )
        {
            return function(e)
            {
                e.preventDefault();

                _self.CloseMenu( this._loop );
            }

        } // _OnBtnPopupClose

        _OnBtnPopupOpen( _self )
        {
            return function(e)
            {
                e.preventDefault();

                _self.OpenMenu( this._loop );

            } //

        } // _OnBtnPopupOpen

        // Escape button for now
        _OnKey( _self )
        {
            return function(e)
            {
                switch(e.code)
                {
                case 'Escape':
                    _self.CloseMenu( null );
                    break;
                }
            }

        } // _OnKey

        _HideAll()
        {
            this.popup_body.style['transition-duration'] = null;
            this.popup_main.style['transition-duration'] = null;

            this.popup_body.style['transform'] = `translate3d(0, 0, 0)`;

            this.popup.classList.remove( this.options.CLS_OPENED );

        } // _HideAll

    } // IzzyPopup

})(jQuery);
